import React, { useState, useRef, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import vendorsRegister from "../services/vendors-register";
import { useUser } from "../components/context/UserContext";
const VendorOtpVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const vendorGuid = location.state?.vendorGuid;
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const inputsRef = useRef([]);
  const [timer, setTimer] = useState(60);
  const [resendAvailable, setResendAvailable] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { setAuthentication } = useUser();
  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      setResendAvailable(false);
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setResendAvailable(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleOtpChange = (element, index) => {
    const value = element.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "") {
        if (index > 0) {
          inputsRef.current[index - 1].focus();
        }
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    const enteredOtp = otp.join("");

    if (!/^\d{4}$/.test(enteredOtp)) {
      setLoading(false);
      setError("Please enter a valid 4-digit OTP.");
      return;
    }
    if (!vendorGuid) {
      setError("Something went wrong. Please try again.");
      setLoading(false);
      return;
    }

    const payload = {
      vendorGuid: vendorGuid,
      otp: enteredOtp,
    };

    try {
      const response = await vendorsRegister.otpVerify(payload);
      console.log("OTP verification response:", response);

      if (response.isSuccess) {
        console.log("OTP verified successfully");

        setAuthentication(true);

        navigate("/vendor-account/vendor-profile");
      } else {
        setError(response.message || "OTP verification failed.");
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false); // 👈 always stop loading
    }
  };

  const handleResendOtp = async () => {
    if (!vendorGuid) {
      setError("Customer ID is missing. Cannot resend OTP.");
      return;
    }

    try {
      setTimer(60); // start the countdown timer
      setResendAvailable(false);

      const payload = { vendorGuid: vendorGuid };
      const response = await vendorsRegister.resendOtp(payload);

      if (response?.isSuccess) {
        setSuccess("OTP resent successfully.");
        setError("");
      } else {
        setError(response?.message || "Failed to resend OTP.");
      }
    } catch (err) {
      console.error("Resend OTP error:", err);
      setError(err.message || "Something went wrong while resending OTP.");
    }
  };

  return (
    <section className="registration-section">
      <div className="container">
        <div className="login-form-wrap">
          <div className="login-form-title">
            <h2 className="form-title">OTP Verification</h2>
            <p className="mb-0">Verify the OTP sent to your mobile number</p>
          </div>

          <Form onSubmit={handleSubmit} className="text-center mt-4">
            <div className="d-flex justify-content-center gap-2 mb-3">
              {otp.map((digit, idx) => (
                <input
                  key={idx}
                  type="text"
                  maxLength="1"
                  className="otp-input form-control text-center"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target, idx)}
                  onKeyDown={(e) => handleKeyDown(e, idx)}
                  ref={(el) => (inputsRef.current[idx] = el)}
                  style={{
                    width: "50px",
                    height: "50px",
                    fontSize: "24px",
                    borderRadius: "8px",
                  }}
                />
              ))}
            </div>

            {/* Show Resend Link or Countdown */}
            <div className="text-start mb-2">
              {resendAvailable ? (
                <p
                  onClick={handleResendOtp}
                  style={{
                    cursor: "pointer",
                    color: "#007bff",
                    textDecoration: "underline",
                    marginBottom: "0",
                  }}
                >
                  Resend OTP
                </p>
              ) : (
                <p className="text-muted mb-0">Resend OTP in {timer}s</p>
              )}
            </div>

            <Button
              type="submit"
              variant="primary"
              className="btn orange-btn w-100 mt-3 mb-3"
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify"}
            </Button>

            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
          </Form>
        </div>
      </div>
    </section>
  );
};

export default VendorOtpVerification;
